export function ChatNewIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0288 12.0833V7.08333M8.52882 9.58333H13.5288M11.0288 16.6667C14.9408 16.6667 18.1122 13.4954 18.1122 9.58333C18.1122 5.67132 14.9408 2.5 11.0288 2.5C7.1168 2.5 3.94549 5.67132 3.94549 9.58333C3.94549 10.375 4.07536 11.1363 4.31496 11.8472C4.40513 12.1147 4.45021 12.2484 4.45834 12.3512C4.46637 12.4527 4.4603 12.5238 4.4352 12.6225C4.40978 12.7224 4.35365 12.8262 4.2414 13.034L2.87835 15.557C2.68393 15.9168 2.58671 16.0968 2.60847 16.2356C2.62742 16.3566 2.69861 16.4631 2.80313 16.5269C2.92314 16.6001 3.12657 16.579 3.53344 16.537L7.80096 16.0958C7.93019 16.0825 7.99481 16.0758 8.05371 16.0781C8.11163 16.0803 8.15253 16.0857 8.20901 16.0987C8.26645 16.112 8.33867 16.1398 8.48312 16.1954C9.27316 16.4998 10.1315 16.6667 11.0288 16.6667Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
